export default __webpack_public_path__ + "static/media/BackgroundVideo.47f7e326.mp4";